export const setApp = ({
  commit
}, data) => {
  commit('setApp', data)
}
